import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nica-right-panel',
  templateUrl: './nica-right-panel.component.html',
  styleUrls: ['./nica-right-panel.component.css']
})
export class NicaRightPanelComponent implements OnInit {

  constructor() { }

  @Input() titolo:string="";

  ngOnInit() {

  }


  apriOffCanvas(){
    document.getElementById("triggerNicaRightPanel").click();
  }
}
